import React, { useEffect, useRef } from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import Autocomplete from '../../custom/autocomplete'
import InputIDCardNumber from '../../input-idcard-num'
import LabelCustom from '../../label-custom'
import UseSexs from '../../../hooks/use-emps-sexs'
import UseNationalitys from '../../../hooks/use-emps-nationalitys'
import { Controller, useForm } from 'react-hook-form'
import moment from 'moment'
import InputNumber from '../../input-number'
import InputPhonePersonal from '../../input-phone-personal'
import useNumberInput from '../../../helper/input-fix-num'
import DatepickerFixYearCustom from '../../datepicker-customfix-year'
import useEngNumInput from '../../../helper/input-fix-en-num'
import CreatableSelectCustom from '../../CreatableSelectCustom'

function PersonalInformation({
  control,
  data,
  setValue,
  errors,
  setError,
  idPassport,
  setIdPassport
}) {
  const dataSexs = UseSexs()
  const nationalitys = UseNationalitys()
  useEffect(() => {
    const nationalitysNew = nationalitys.find(
      (d) => d.label === data?.nationality
    )
    setValue('nationality', nationalitysNew ?? { value: 1, label: 'ไทย' })
    setError('nationality', nationalitysNew)
    const sexNew = dataSexs.find((d) => d.label === data?.sex)
    setValue('sex', sexNew)
    setError('sex', sexNew)
  }, [data, dataSexs, nationalitys, setError, setValue])

  const {
    formState: { isDirty }
  } = useForm()

  const inputRef = useRef(null)
  const handleKeyDownNum = useNumberInput(inputRef)
  const handleKeyDownENnum = useEngNumInput(inputRef)

  return (
    <Card border="0">
      <Card.Body>
        <h5 className="mb-3 fw-bold">ข้อมูลส่วนตัว</h5>
        <Row style={{ rowGap: '15px' }}>
          <Col xl={3}>
            <LabelCustom text="วันเกิด (ค.ศ.)" />
            <Controller
              name={'birthday'}
              control={control}
              render={({ field: { value = '' } }) => (
                <DatepickerFixYearCustom
                  value={value}
                  onChange={([date]) => {
                    setValue(
                      'birthday',
                      date ? moment(date).format('YYYY-MM-DD') : ''
                    )
                    setError('birthday', date)
                  }}
                />
              )}
            />
            {errors.birthday?.message && (
              <label className="small text-danger">
                {errors.birthday.message}
              </label>
            )}
          </Col>
          <Col xl={3}>
            <LabelCustom text="เพศ" />
            <Controller
              name={'sex'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Autocomplete
                  options={dataSexs}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.sex?.message && (
              <label className="small text-danger">{errors.sex.message}</label>
            )}
          </Col>
          <Col xl={3}>
            <LabelCustom text="สัญชาติ" />
            <Controller
              name={'nationality'}
              control={control}
              render={({ field: { value = '', onChange } }) => (
                <Autocomplete
                  options={nationalitys}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.nationality?.message && (
              <label className="small text-danger">
                {errors.nationality.message}
              </label>
            )}
          </Col>

          <Col xl={3}>
            <label className="pointer-event">
              <span
                className={`fw-light small ${
                  idPassport === 2 ? 'opacity-25' : ''
                }`}
                onClick={() => setIdPassport(1)}
              >
                เลขประจำตัวประชาชน
              </span>
              <span className="opacity-25">/</span>
              <span
                className={` fw-light small ${
                  idPassport === 1 ? 'opacity-25' : ''
                }`}
                onClick={() => setIdPassport(2)}
              >
                เลขพาสปอร์ต
              </span>
            </label>
            <Controller
              name={'id_card'}
              control={control}
              render={({ field: { value = '', onChange } }) =>
                idPassport === 2 ? (
                  <InputNumber value={value} onChange={onChange} />
                ) : (
                  <InputIDCardNumber value={value} onChange={onChange} />
                )
              }
            />
            {errors.id_card?.message && (
              <label className="small text-danger">
                {errors.id_card.message}
              </label>
            )}
          </Col>
          <Col xl={3}>
            <LabelCustom text="ส่วนสูง" />
            <Controller
              name={'height'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  type="number"
                  value={value}
                  onChange={onChange}
                  onKeyDown={handleKeyDownNum}
                />
              )}
            />
            {errors.height?.message && (
              <label className="small text-danger">
                {errors.height.message}
              </label>
            )}
          </Col>
          <Col xl={3}>
            <LabelCustom text="น้ำหนัก " />
            <Controller
              name={'weight'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  type="number"
                  value={value}
                  onChange={onChange}
                  onKeyDown={handleKeyDownNum}
                />
              )}
            />
            {errors.weight?.message && (
              <label className="small text-danger">
                {errors.weight.message}
              </label>
            )}
          </Col>
          <Col xl={3}>
            <LabelCustom text="เบอร์มือถือ" />
            <Controller
              name={'mobile'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <InputPhonePersonal
                  isDirty={isDirty}
                  onKeyDown={handleKeyDownNum}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.mobile?.message && (
              <label className="small text-danger">
                {errors.mobile.message}
              </label>
            )}
          </Col>
          {/* <Col xl={3}>
            <LabelCustom text="ทะเบียนรถ" subtext={'(ถ้ามี)'} />
            <Controller
              name={'licensePlate'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control value={value} onChange={onChange} />
              )}
            />
          </Col> */}
          <Col xl={3}>
            <LabelCustom text="ทะเบียนรถยนต์" subtext={'(ถ้ามี)'} />
            <Controller
              name={'licensePlateCar'}
              control={control}
              render={({ field: { onChange, value } }) => (
                <CreatableSelectCustom
                  maxLength={2}
                  value={value}
                  blockInput={[',', ' ']}
                  onChange={onChange}
                />
              )}
            />
          </Col>
          <Col xl={3}>
            <LabelCustom text="ทะเบียนรถจักรยานยนต์" subtext={'(ถ้ามี)'} />
            <Controller
              name={'licensePlateMoto'}
              control={control}
              render={({ field: { onChange, value } }) => (
                <CreatableSelectCustom
                  maxLength={2}
                  value={value}
                  blockInput={[',', ' ']}
                  onChange={onChange}
                />
              )}
            />
          </Col>
          <Col xl={3}>
            <LabelCustom text="อีเมล" subtext={'(ถ้ามี)'} />
            <Controller
              name={'personalemail'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  type="email"
                  value={value}
                  onChange={onChange}
                  onKeyDown={handleKeyDownENnum}
                />
              )}
            />
            {errors.personalemail?.message && (
              <label className="small text-danger">
                {errors.personalemail.message}
              </label>
            )}
          </Col>
          <Col xl={3}>
            <LabelCustom text="LINE ID" subtext={'(ถ้ามี)'} />
            <Controller
              name={'id_line'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  value={value}
                  onChange={onChange}
                  onKeyDown={handleKeyDownENnum}
                />
              )}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}

export default PersonalInformation
